{
  "homeTitle": "Administrasyon",
  "homeLead": "Mga tanggapan, staff account at setting ng {lgu}.",
  "statusOk": "gumagana",
  "statusNotConfigured": "hindi pa naka-set up",
  "emergencyOnTitle": "Naka-on ang emergency mode",
  "emergencyOnSince": "Mula {date}.",
  "manageEmergency": "Pamahalaan ang emergency mode",
  "setupNeededTitle": "May mga serbisyong hindi pa naka-set up",
  "setupNeededBody": "Gumagana ang app, pero nilalaktawan ang mga may marka sa ibaba hangga't hindi naidaragdag ang kanilang mga key sa server.",
  "systemTitle": "Kalagayan ng sistema",
  "smsTitle": "SMS (responder, paalala)",
  "smsOk": "Nagpapadala sa pamamagitan ng {provider}.",
  "smsMissing": "Hindi pa naka-set up (SEMAPHORE_API_KEY). Itinatala ang mga text pero hindi naipapadala, at may babala sa mga dispatcher.",
  "smsWeek": "Nakaraang 7 araw: {sent} naipadala, {failed} pumalya, {skipped} hindi naipadala.",
  "mailTitle": "Email (beripikasyon, pag-reset ng password, imbitasyon)",
  "mailOk": "Nagpapadala sa pamamagitan ng {provider}.",
  "mailMissing": "Hindi pa naka-set up (RESEND_API_KEY). Sa server log lang lumalabas ang mga link — kopyahin ang link ng imbitasyon sa Mga staff account.",
  "pushTitle": "Push notification",
  "pushOk": "Handa na ang Web Push.",
  "pushMissing": "Hindi pa naka-set up (VAPID keys). Hindi pa makakapag-on ng notification ang mga residente. Gumawa ng key gamit ang npm run keys:vapid.",
  "mapTitle": "Offline na mapa",
  "mapOk": "May nakahandang backup na mapa, kaya gumagana ang mapa kahit down ang OpenFreeMap o offline ang telepono.",
  "mapMissing": "Walang backup na mapa (MAP_FALLBACK_PMTILES_URL). Kailangang maabot ang OpenFreeMap para gumana ang mapa.",
  "countsTitle": "Sa isang tingin",
  "countOffices": "Aktibong tanggapan",
  "countStaff": "Aktibong staff",
  "countInvited": "Imbitasyong hindi pa tinatanggap",
  "countResidents": "Account ng residente",
  "countPosts": "Nakalathalang post",
  "countPending": "Post na naghihintay ng pag-apruba",
  "countEmergency": "Bukas na ulat ng emergency",
  "countCrop": "Ulat ng pinsala sa pananim na susuriin",
  "countAudit": "Naitalang aksyon (24 oras)",
  "linksTitle": "Pamahalaan",
  "linkOffices": "Mga tanggapan",
  "linkOfficesHint": "Magdagdag ng tanggapan, i-edit ang profile, magbigay ng feature.",
  "linkStaff": "Mga staff account",
  "linkStaffHint": "Mag-imbita ng staff, magpalit ng tungkulin, mag-deactivate.",
  "linkSettings": "Setting ng LGU",
  "linkSettingsHint": "Pangalan ng app, selyo, accent na kulay, contact sa privacy.",
  "linkEmergency": "Emergency mode",
  "linkEmergencyHint": "Ilagay sa itaas ang mga abiso at tulong sa paglikas.",
  "linkHotlines": "Mga hotline",
  "linkHotlinesHint": "Mga numerong matatawagan ng residente, kahit offline.",
  "linkResponders": "Mga responder team",
  "linkRespondersHint": "Sino ang tine-text tungkol sa mga ulat ng emergency.",
  "linkDisasters": "Mga sakuna",
  "linkDisastersHint": "Pagsama-samahin ang ulat ng pinsala sa pananim ayon sa bagyo o baha.",
  "linkCategories": "Mga kategorya",
  "linkCategoriesHint": "Mga paksang sinasala at sinusundan ng residente.",
  "linkAudit": "Audit log",
  "linkAuditHint": "Sino ang nagbago ng ano, at kailan.",
  "linkSms": "SMS log",
  "linkSmsHint": "Lahat ng text na sinubukang ipadala ng app.",
  "officesTitle": "Mga tanggapan",
  "officesLead": "Lahat ng tanggapan ng munisipyo at barangay na nagpo-post sa app. Magdagdag ng tanggapan, i-edit ang pampublikong profile nito, at piliin ang mga dagdag na work screen na magagamit ng bawat isa.",
  "officesBaseNote": "Lahat ng tanggapan ay makakapag-post ng anunsiyo, iskedyul at programa at makakapamahala ng rehistrasyon. Dagdag na work screen ang mga feature na ibibigay mo rito.",
  "newOffice": "Magdagdag ng tanggapan",
  "createOffice": "Gumawa ng tanggapan",
  "officeCreated": "Nagawa na ang {name}. Idagdag naman ang profile at mga feature nito.",
  "officeSaved": "Na-save ang tanggapan.",
  "editOffice": "I-edit ang {name}",
  "officeSections": "Setting ng tanggapan",
  "tabDetails": "Detalye",
  "tabProfile": "Profile",
  "tabFeatures": "Mga feature",
  "officeName": "Pangalan ng tanggapan",
  "officeShortName": "Maikling pangalan",
  "officeShortNameHint": "Lumalabas sa mga post at menu, hal. \"MDRRMO\".",
  "officeSlug": "Pangalan sa web",
  "officeSlugHint": "Ginagamit sa link: /offices/{slug}",
  "officeSlugHintEdit": "Ginagamit sa link: /offices/{slug}. Kapag pinalitan, hindi na gagana ang mga link na naibahagi na.",
  "officeType": "Uri",
  "type_municipal": "Tanggapan ng munisipyo",
  "type_barangay": "Barangay",
  "typePlural_municipal": "Mga tanggapan ng munisipyo",
  "typePlural_barangay": "Mga barangay",
  "officeIcon": "Icon",
  "officeActive": "Aktibo",
  "officeActiveHint": "Nawawala sa app ang mga na-deactivate na tanggapan, hindi na lumalabas ang kanilang mga post, at hindi na mabubuksan ng kanilang staff ang workspace.",
  "confirmDeactivateOffice": "I-deactivate ang {name}? Mawawala ito sa app at mawawalan ng access ang staff nito sa workspace hangga't hindi mo ito ina-activate muli.",
  "searchOffices": "Maghanap ng tanggapan",
  "showDeactivated": "Ipakita ang mga na-deactivate",
  "noOffices": "Walang tumugmang tanggapan.",
  "memberCount": "{count} staff",
  "updated": "binago {date}",
  "deactivated": "Na-deactivate",
  "profileLead": "Ito ang pampublikong pahina ng tanggapan sa app: kung ano ang ginagawa nito, nasaan ito at paano ito makakausap. Maaari rin itong i-edit ng pinuno ng tanggapan.",
  "profileSaved": "Na-save ang profile.",
  "saveProfile": "I-save ang profile",
  "officeLogo": "Logo",
  "officeLogoHint": "Opsiyonal. Parisukat na PNG o JPG. Kung walang logo, ang icon ang ipapakita.",
  "officeDescription": "Ano ang ginagawa ng tanggapan",
  "officeLocation": "Lokasyon",
  "officeHours": "Oras ng opisina",
  "officeHoursHint": "Halimbawa: Lunes hanggang Biyernes, 8:00 AM – 5:00 PM",
  "officePhone": "Telepono",
  "officeEmail": "Email",
  "officeOtherContact": "Iba pang contact",
  "officeOtherContactHint": "Halimbawa, ang Facebook page ng tanggapan.",
  "featuresLead": "Piliin ang mga work screen na magagamit ng {name}. Magkakabisa ang pagbabago sa susunod na buksan ng staff ang workspace.",
  "featuresSaved": "Na-save ang mga feature.",
  "saveFeatures": "I-save ang mga feature",
  "capBase": "Post, iskedyul at rehistrasyon",
  "capBaseHint": "Laging naka-on para sa lahat ng tanggapan.",
  "capLater": "Darating pa ang screen",
  "cap_dispatch": "Emergency dispatch",
  "capHint_dispatch": "Live na pila ng mga ulat ng emergency na may SMS sa responder.",
  "cap_crop_damage": "Pinsala sa pananim",
  "capHint_crop_damage": "Suriin ang ulat ng magsasaka sa pinsala sa pananim at i-export para sa DA.",
  "cap_evacuation": "Mapa ng evacuation",
  "capHint_evacuation": "I-edit ang evacuation site, dami ng tao, mapanganib na lugar at saradong kalsada.",
  "cap_tax": "Buwis",
  "capHint_tax": "Pagtasa ng cedula at amilyar (real property tax).",
  "cap_civil_registry": "Civil registry",
  "capHint_civil_registry": "Mga kahilingan para sa birth, marriage at death certificate.",
  "cap_permits": "Mga permit",
  "capHint_permits": "Aplikasyon para sa business at building permit.",
  "cap_queue": "Virtual na pila",
  "capHint_queue": "Ticket sa pila na may live na \"now serving\".",
  "cap_facilities": "Pag-book ng pasilidad",
  "capHint_facilities": "Pag-book ng gym, bulwagan at court.",
  "cap_waste": "Basura at recycling",
  "capHint_waste": "Iskedyul ng koleksiyon at pagkuha ng recyclables.",
  "cap_tourism": "Turismo",
  "capHint_tourism": "Mga pasyalan, trail, guide at rehistrasyon ng bisita.",
  "cap_market_prices": "Presyo sa palengke",
  "capHint_market_prices": "Araw-araw na presyo ng gulay na may tsart ng takbo.",
  "cap_emergency_mode": "Emergency mode",
  "capHint_emergency_mode": "I-on ang emergency banner sa buong bayan habang may sakuna.",
  "cap_town_wide_urgent_alerts": "Agarang abiso sa buong bayan",
  "capHint_town_wide_urgent_alerts": "Markahan bilang agaran ang post para mauna itong makita ng lahat ng residente.",
  "staffTitle": "Mga staff account",
  "staffLead": "Iniimbitahan sa email ang staff at hindi sila nagsa-sign up nang mag-isa. Kapag na-deactivate ang account, agad itong masa-sign out sa lahat ng device.",
  "emailOffInvites": "Hindi naka-set up ang email kaya hindi naipapadala ang imbitasyon. Pagkatapos mag-imbita, ikaw mismo ang magpadala ng link: lalabas ito rito, o sa server log habang nasa development.",
  "inviteStaff": "Mag-imbita ng staff",
  "inviteLead": "Gamitin ang opisyal na email ng tao sa tanggapan. Kung may staff account na siya, idaragdag na lang siya sa tanggapan.",
  "inviteEmailHint": "Hindi maaaring gawing staff account ang account ng residente.",
  "office": "Tanggapan",
  "chooseOffice": "Pumili ng tanggapan",
  "chooseOfficeError": "Piliin ang tanggapan kung saan nagtatrabaho ang taong ito.",
  "allOffices": "Lahat ng tanggapan",
  "role": "Tungkulin sa tanggapang ito",
  "roleIn": "Tungkulin sa {office}",
  "roleHint_office_head": "Namamahala sa staff at profile ng tanggapan, at kayang gawin ang lahat sa ibaba.",
  "roleHint_editor": "Naglalathala ng post at namamahala ng rehistrasyon.",
  "roleHint_contributor": "Gumagawa ng draft na post na aaprubahan ng editor o pinuno.",
  "roleHint_viewer": "Nakakatingin lang sa rehistrasyon at mga ulat.",
  "sendInvite": "Ipadala ang imbitasyon",
  "inviting": "Ipinapadala…",
  "inviteSent": "Naipadala ang imbitasyon kay {email}. Gagana ang link sa loob ng 7 araw.",
  "inviteNotEmailed": "Inimbitahan si {email}, pero hindi naka-set up ang email kaya walang naipadala.",
  "inviteLogged": "Inimbitahan si {email}. Hindi naka-set up ang email kaya sa server log lumabas ang link ng imbitasyon (sa development lang). Ikaw mismo ang magpadala nito sa kanya.",
  "inviteAdded": "May staff account na si {email} at idinagdag na siya sa {office}.",
  "inviteUpdated": "Nasa {office} na si {email}; binago ang kanyang tungkulin.",
  "inviteLink": "Link ng imbitasyon",
  "inviteLinkHint": "Ipadala ang link na ito sa tao (halimbawa sa SMS o chat). Gagana ito sa loob ng 7 araw.",
  "copy": "Kopyahin",
  "copyFailed": "Hindi makopya. Piliin ang link at kopyahin nang mano-mano.",
  "inviteAnother": "Mag-imbita ng iba pa",
  "addToOffice": "Idagdag sa tanggapan",
  "searchStaff": "Pangalan o email",
  "noStaff": "Walang tumugmang staff account.",
  "noNameYet": "Hindi pa tinatanggap ang imbitasyon",
  "status_active": "Aktibo",
  "status_invited": "Inimbitahan",
  "status_deactivated": "Na-deactivate",
  "administrator": "Administrator",
  "lastSignIn": "Huling nag-sign in {date}",
  "neverSignedIn": "Hindi pa nakakapag-sign in",
  "noMemberships": "Wala pa sa anumang tanggapan.",
  "removeFromOffice": "Alisin si {name} sa {office}",
  "confirmRemoveMembership": "Alisin si {name} sa {office}? Agad siyang mawawalan ng access sa workspace ng tanggapang iyon.",
  "membershipRemoved": "Inalis sa tanggapan.",
  "roleChanged": "{role} na ngayon si {name}.",
  "deactivate": "I-deactivate",
  "reactivate": "I-activate muli",
  "confirmDeactivate": "I-deactivate si {name}? Agad siyang masa-sign out sa lahat ng device at hindi makakapag-sign in hangga't hindi mo ina-activate muli ang account.",
  "confirmReactivate": "I-activate muli si {name}? Makakapag-sign in na siya ulit, kasama ang dati niyang mga tanggapan at tungkulin.",
  "deactivatedDone": "Na-deactivate si {name} at na-sign out sa lahat ng device.",
  "reactivated": "Na-activate muli si {name}.",
  "grantAdmin": "Gawing administrator",
  "revokeAdmin": "Alisin bilang administrator",
  "confirmGrantAdmin": "Gawing platform administrator si {name}? Kayang baguhin ng administrator ang lahat ng tanggapan, staff account at setting.",
  "confirmRevokeAdmin": "Alisin ang access bilang administrator ni {name}?",
  "adminGranted": "Administrator na si {name}.",
  "adminRevoked": "Hindi na administrator si {name}.",
  "thisIsYou": "Ito ang iyong account.",
  "settingsTitle": "Setting ng LGU",
  "settingsLead": "Kung paano pinapangalanan at ipinapakita ng app ang LGU.",
  "settingsAppliesNote": "Agad na makikita ng lahat ang pagbabago: ang pangalan ng app sa screen, ang naka-install na app, mga pamagat ng pahina, email, SMS at preview ng ibinahaging link.",
  "identityTitle": "Pangalan at selyo",
  "displayName": "Pangalan ng app",
  "displayNameHint": "Ipinapakita bilang pangalan ng app, hal. \"Limitless La Trinidad\".",
  "lguName": "Opisyal na pangalan ng LGU",
  "lguNameHint": "Hal. \"Municipality of La Trinidad\". Ginagamit sa email at sa mga pahinang About at Privacy.",
  "province": "Lalawigan",
  "tagline": "Tagline",
  "taglineHint": "Isang maikling linya sa ilalim ng pangalan ng app.",
  "seal": "Selyo o logo ng LGU",
  "sealHint": "Ipinapakita sa tabi ng iLi mark. Pinakamainam ang parisukat na PNG na walang background.",
  "sealSaved": "Napalitan ang selyo.",
  "sealRemoved": "Inalis ang selyo.",
  "uploadImage": "Mag-upload ng larawan",
  "replaceImage": "Palitan ang larawan",
  "removeImage": "Alisin",
  "uploading": "Ina-upload…",
  "brandTitle": "Accent na kulay",
  "accentTitle": "Accent na kulay",
  "accentLead": "Ginagamit sa mga highlight at badge. Nananatiling Pine green ang mga button at teksto para laging madaling basahin.",
  "accentPicker": "Pumili ng kulay",
  "accentHex": "Hex code",
  "accentReset": "Gamitin ang default",
  "accentInvalid": "Maglagay ng kulay tulad ng #C27638.",
  "accentRed": "Nakalaan ang pula para sa mga emergency button at agarang abiso. Pumili ng ibang kulay.",
  "accentNotRed": "Hindi pula, kaya litaw pa rin ang mga emergency button.",
  "accentOnWhite": "Sa puti: {ratio} (kailangan ng {need} para sa icon at highlight).",
  "accentOnGround": "Sa background ng pahina: {ratio} (kailangan ng {need}).",
  "accentBadgeText": "Mas madilim na kulay ang teksto sa badge: {ratio} (kailangan ng {need}).",
  "accentFix": "Hindi pumasa ang kulay na ito sa mga pagsusuri. Pumili ng iba.",
  "dpoTitle": "Data Protection Officer",
  "dpoLead": "Ipinapakita sa pahina ng privacy (Data Privacy Act of 2012, RA 10173). Habang wala pang laman, placeholder ang ipinapakita sa pahina.",
  "dpoName": "Pangalan",
  "dpoEmail": "Email",
  "dpoPhone": "Telepono",
  "cropsTitle": "Mga pananim",
  "cropsLabel": "Mga pananim sa form ng pinsala sa pananim",
  "cropsHint": "Isang pananim bawat linya, sa pagkakasunod na dapat makita ng magsasaka. Ilagay sa huli ang \"Other\".",
  "cropsRequired": "Maglagay ng kahit isang pananim.",
  "mapViewTitle": "Tanaw ng mapa",
  "mapViewLead": "Kung saan bubukas ang mapa sa unang pagbukas nito.",
  "mapLat": "Latitude",
  "mapLng": "Longitude",
  "mapZoom": "Zoom (5–19)",
  "mapOutside": "Maglagay ng puntong nasa loob ng saklaw ng mapa ng LGU.",
  "mapZoomRange": "Dapat nasa pagitan ng 5 at 19 ang zoom.",
  "mapBounds": "Ang saklaw ng mapa ng LGU ay mula {w}, {s} hanggang {e}, {n} (longitude, latitude). Nakatakda ito sa config file dahil dito kinukuha ang offline na mapa.",
  "fixedTitle": "Nakatakda sa configuration file",
  "fixedLead": "Galing ang mga ito sa config/lgu.{slug}.json at nagbabago lang sa bagong deployment.",
  "fixedSlug": "Code ng LGU",
  "fixedAppId": "App ID",
  "fixedTimezone": "Time zone",
  "fixedPoweredBy": "Plataporma",
  "previewTitle": "Preview",
  "previewBadge": "Highlight",
  "previewOpen": "Bukas ang rehistrasyon",
  "previewShare": "Preview ng ibinahaging link",
  "previewShareText": "{tagline}. Mga iskedyul, programa, rehistrasyon at abiso mula sa bawat tanggapan ng {lgu}.",
  "unsaved": "May mga pagbabagong hindi pa na-save.",
  "lastSaved": "Huling na-save {date}",
  "discard": "Itapon ang mga pagbabago",
  "saveSettings": "I-save ang setting",
  "settingsSaved": "Na-save ang setting. Nakikita na ng lahat ang pagbabago.",
  "fixErrors": "Pakiayos ang mga field na may marka.",
  "categoriesTitle": "Mga kategorya",
  "categoriesLead": "Nilalagyan ng tanggapan ng kategorya ang bawat post. Sinasala at sinusundan ng residente ang mga kategorya, ayon sa pagkakasunod dito.",
  "newCategory": "Magdagdag ng kategorya",
  "editCategory": "I-edit ang {name}",
  "noCategories": "Wala pang kategorya.",
  "categoryName": "Pangalan",
  "categorySlug": "Pangalan sa web",
  "categorySlugHint": "Ginagamit sa link at filter. Maliliit na titik, numero at gitling.",
  "categoryIcon": "Icon",
  "categoryActive": "Aktibo",
  "categoryActiveHint": "Nakatago sa filter at sa bagong post ang mga hindi aktibong kategorya. Mananatili ang kategorya ng mga lumang post.",
  "categorySaved": "Na-save ang kategorya.",
  "inactive": "Hindi aktibo",
  "moveUp": "Itaas ang {name}",
  "moveDown": "Ibaba ang {name}",
  "auditTitle": "Audit log",
  "auditLead": "Itinatala ang bawat aksyon ng staff at administrator: sino ang nagbago ng ano, at kailan. Hindi maaaring baguhin o burahin ang mga tala.",
  "auditActor": "Sino",
  "auditActorPlaceholder": "Pangalan o email",
  "auditAction": "Aksyon",
  "auditAnyAction": "Anumang aksyon",
  "auditRecord": "Rekord",
  "auditAnyRecord": "Anumang rekord",
  "auditBy": "Ni",
  "auditSystem": "Sistema",
  "auditOffice": "bilang {office}",
  "auditShowChanges": "Ipakita ang binago ({count})",
  "auditField": "Field",
  "auditBefore": "Dati",
  "auditAfter": "Ngayon",
  "auditValue": "Halaga",
  "auditEmpty": "Wala pang naitatala.",
  "auditNoMatch": "Walang talang tumugma sa mga filter na ito.",
  "clearFilters": "I-clear ang mga filter",
  "smsLogTitle": "SMS log",
  "smsLogLead": "Lahat ng text na sinubukang ipadala ng app, kasama ang mga hindi naipadala dahil hindi naka-set up ang SMS.",
  "smsOffTitle": "Hindi naka-set up ang SMS",
  "smsOffBody": "Itinatala rito ang mga mensahe pero hindi naipapadala. Idagdag ang SEMAPHORE_API_KEY sa server para magsimulang magpadala. Ganito rin ang babalang nakikita ng mga dispatcher.",
  "smsLast7": "Nakaraang 7 araw",
  "sms_sent": "Naipadala",
  "sms_failed": "Pumalya",
  "sms_not_configured": "Hindi naipadala (naka-off ang SMS)",
  "smsSearch": "Numero o teksto",
  "smsSearchPlaceholder": "0917 123 4567",
  "smsPurpose": "Layunin",
  "smsRelated": "Tungkol sa",
  "smsProvider": "Provider",
  "smsSentBy": "Ipinadala ni {email}",
  "smsError": "Error",
  "smsEmpty": "Wala pang text message.",
  "smsNoMatch": "Walang mensaheng tumugma sa mga filter na ito.",
  "capElsewhere": "Hawak ng ibang app",
  "cap_transparency": "Transparency",
  "capHint_transparency": "Maglathala ng mga dokumento, bidding at award, at direktoryo ng mga opisyal.",
  "cap_ordinances": "Mga ordinansa",
  "capHint_ordinances": "Subaybayan ang mga ordinansa at resolusyon mula paghahain hanggang pag-apruba.",
  "cap_community_moderation": "Pag-moderate ng komunidad",
  "capHint_community_moderation": "Suriin ang mga panukala at post sa nawala at natagpuan bago ito makita ng publiko."
}
